import { theme } from '../../../../Assets/Styles/theme'

export const styles = {
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonLabel: {
    marginLeft: 10,
    fontSize: 16,
    color: theme.colors.primary,
  },

  error: {
    color: '#FF0000',
    position: 'absolute',
    bottom: '-20px',
  },
  userRow: { marginBottom: '20px', display: 'flex', alignItems: 'flex-end' },
  button: {
    height: '44px',
    width: '32px',
    padding: '22px',
    minWidth: '34px',
  },
}
